import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import axios from 'axios';
import forEach from 'lodash/forEach';

import css from './jobList.scss';

import CornerLabel from '../../block/cornerLabel';
import PostVacancy from '../../jobs/postVacancy';
import JobListing from '../../jobs/listing';

import { jobsRoute } from '../../../routes/index';

import baseUrl from '../../../utils/baseUrl';
let url = baseUrl + '/api/jobs?offset=0&limit=3';

export default class GlobalNavJobList extends Component {
	static propTypes = {};

	constructor(props) {
		super();

		this.state = {
			jobs: [],
		};
	}

	componentWillMount() {
		axios.get(url).then((response) => {
			let _jobs = [];

			forEach(response.data.jobs, function(job) {
				let local = {
					id: job.id,
					title: job.title,
					profileName: job.profiles ? job.profiles.name : '',
					postedDate: job.createdDate,
					slug: job.slug,
					location: job.city + ', ' + job.country,
				};

				_jobs.push(local);
			});

			this.setState({
				...this.state,
				jobs: _jobs,
			});
		}).catch((response) => {
			console.log('fetching global nav jobs error');
			console.log(response);
		});
	}

	componentDidMount() {
			//console.log(jobs);
	}

	render() {
		return (
			<div className='globalnav__joblist'>
				<div className='globalnav__joblist__head'>
					<CornerLabel name='Jobs'/>

					<PostVacancy dispatch={this.props.dispatch}/>
				</div>

				<ul className='globalnav__joblist__list'>
					{this.state.jobs.map((job) => {
						if (!job.id) {
							return false;
						}

						return (
							<li key={job.id}>
								<JobListing job={job} listStyle={1} className='' dispatch={this.props.dispatch} />
							</li>
						);
					})}
				</ul>
			</div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/globalNav/jobList/jobList.js
 **/